import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {PROTOCOLS} from "../../util/Validations";
import {ADTA_ASSET_TYPE} from "../../util/Constants";
import {AdtaDeviceOverviewContext} from "./context/AdtaDeviceOverviewContext";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";

const AdtaDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);
    const deviceList = Object.values(viewModel.adtaDeviceInformation);

    const props = {
        protocols: PROTOCOLS.ADTA,
        dispatch,
        deviceList,
        deviceType: ADTA_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(AdtaDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/AdtaDeviceLogstream.js